/** End-customer copy per public failure reason. Unbranded (no HookMyApp name)
 *  and mechanics-free — mirrors backend PUBLIC_FAILURE_REASONS (spec D1). */
export const REASON_COPY: Record<string, string> = {
  customer_cancelled: 'The connection was cancelled. You can try again from the link you received.',
  permission_denied: 'The connection was not approved. Please try again and approve the requested access.',
  already_connected: 'This account is already connected to another service. Disconnect it there, then try again.',
  no_number_available: 'No WhatsApp number was available to connect. Finish setting up your WhatsApp Business account, then try again.',
  no_page_available: 'No Facebook Page was available to connect. Make sure your Facebook profile has full control of the Page, then open the link again, choose "Edit previous settings" in the Facebook window, select your Page, and try again.',
  number_activation_blocked: 'This number could not be activated. Turn off two-step verification for it in WhatsApp Manager and make sure your WhatsApp Business account is verified, then try again.',
  link_inactive: 'This link is no longer active. Please ask for a new connection link.',
  temporary_failure: 'Something went wrong. Please try again from the link you received.',
  service_error: 'Something went wrong on our side. Please try again later.',
};

export function reasonCopy(reason: string | null): string {
  return (reason && REASON_COPY[reason]) || REASON_COPY.temporary_failure;
}
